const SpringLeagueIcon = ({ width = '100%', height = null }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 530 572"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_2167_88019)">
        <path
          d="M497.215 118.882L277.886 10.8908C274.07 8.99935 269.857 8.00944 265.582 8.00007C261.307 7.99069 257.09 8.96211 253.265 10.8368L32.4513 118.828C24.2811 122.878 18.6418 130.626 17.4864 139.536C17.1288 142.155 -14.0113 402.522 252.44 544.72C256.536 546.913 261.135 548.041 265.8 547.999C270.466 547.956 275.043 546.744 279.096 544.477C535.122 402.495 513.307 151.037 512.262 140.4C511.811 135.857 510.195 131.501 507.563 127.738C504.932 123.975 501.371 120.928 497.215 118.882Z"
          fill="white"
        />
      </g>
      <path
        d="M474.333 134.539L276.585 37.1728C273.145 35.4674 269.346 34.5749 265.492 34.5665C261.638 34.558 257.835 35.4339 254.387 37.1241L55.2995 134.49C47.9333 138.141 42.8488 145.127 41.8071 153.16C41.4847 155.521 13.4086 390.271 253.643 518.477C257.336 520.454 261.482 521.471 265.689 521.433C269.895 521.395 274.022 520.302 277.676 518.258C508.511 390.246 488.843 163.529 487.9 153.939C487.494 149.843 486.036 145.916 483.664 142.523C481.291 139.13 478.081 136.383 474.333 134.539Z"
        fill="#FFD60D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.631 56.5796L266.604 56.5664C266.244 56.3878 265.846 56.2943 265.443 56.2934C265.039 56.2925 264.641 56.3843 264.28 56.5613L264.261 56.5704L65.2527 153.898C64.3775 154.342 63.8681 155.133 63.7682 155.903L63.759 155.975L63.7492 156.046C63.7517 156.028 63.7498 156.045 63.7441 156.097C63.5204 158.134 57.4889 213.051 78.7177 282.373C100.301 352.852 150.058 438.465 264.219 499.39L264.243 499.403C264.623 499.606 265.05 499.711 265.483 499.707C265.916 499.703 266.341 499.591 266.717 499.38L266.751 499.361L266.785 499.342C485.239 378.196 466.659 164.154 465.866 156.044C465.822 155.604 465.666 155.182 465.411 154.818C465.156 154.453 464.811 154.158 464.409 153.96L474.281 134.641L464.406 153.959L266.631 56.5796ZM487.9 153.939C488.843 163.529 508.511 390.246 277.676 518.258C274.022 520.302 269.895 521.395 265.689 521.433C261.482 521.471 257.336 520.454 253.643 518.477C13.4086 390.271 41.4847 155.521 41.8071 153.16C42.8488 145.127 47.9333 138.141 55.2995 134.49L254.387 37.1241C257.835 35.4339 261.638 34.558 265.492 34.5665C269.346 34.5749 273.145 35.4674 276.585 37.1728L474.333 134.539C478.081 136.383 481.291 139.13 483.664 142.523C486.036 145.916 487.494 149.843 487.9 153.939Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M263.723 76.8164C266.441 76.8164 268.643 79.6571 268.643 83.1613L268.643 133.51C268.643 137.014 266.44 139.854 263.723 139.854C261.006 139.854 258.804 137.014 258.804 133.51L258.804 83.1612C258.804 79.6571 261.006 76.8164 263.723 76.8164Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M264.984 407.785C267.701 407.785 269.904 409.149 269.904 410.832V462.432C269.904 464.114 267.701 465.478 264.984 465.478C262.267 465.478 260.064 464.114 260.064 462.432V410.832C260.064 409.149 262.267 407.785 264.984 407.785Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M406.088 230.274C406.088 227.607 408.29 225.445 411.008 225.445H435.57C438.287 225.445 440.49 227.607 440.49 230.274C440.49 232.94 438.287 235.102 435.57 235.102H411.008C408.29 235.102 406.088 232.94 406.088 230.274Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.521 262.117C126.521 259.451 124.318 257.289 121.601 257.289H97.0383C94.3213 257.289 92.1187 259.451 92.1187 262.117C92.1187 264.784 94.3213 266.945 97.0383 266.945H121.601C124.318 266.945 126.521 264.784 126.521 262.117Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M332.22 105.084C334.669 106.238 335.702 109.122 334.526 111.526L322.011 137.115C320.835 139.518 317.897 140.532 315.447 139.378C312.998 138.224 311.965 135.34 313.141 132.936L325.656 107.347C326.831 104.943 329.77 103.93 332.22 105.084Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M392.38 134.845C394.339 136.692 394.402 139.749 392.519 141.671L375.966 158.545C374.084 160.468 370.969 160.529 369.01 158.682C367.051 156.834 366.988 153.778 368.871 151.855L385.424 134.981C387.307 133.058 390.421 132.997 392.38 134.845Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M444.171 168.597C445.643 170.838 444.986 173.826 442.703 175.271L409.208 196.473C406.924 197.918 403.88 197.273 402.407 195.032C400.934 192.791 401.592 189.803 403.875 188.358L437.37 167.156C439.653 165.711 442.698 166.356 444.171 168.597Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M352.139 346.869C353.464 344.541 356.461 343.709 358.833 345.01L382.735 358.12C385.107 359.421 385.955 362.362 384.63 364.69C383.304 367.018 380.307 367.85 377.935 366.549L354.033 353.439C351.661 352.138 350.813 349.197 352.139 346.869Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M308.57 407.855C310.932 406.537 313.935 407.346 315.279 409.664L326.216 425.962C327.56 428.28 326.735 431.228 324.374 432.547C322.012 433.866 319.008 433.056 317.665 430.739L306.728 414.44C305.384 412.122 306.209 409.174 308.57 407.855Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M399.399 307.336C400.96 305.154 404.028 304.626 406.252 306.158L411.576 309.825C413.8 311.357 414.338 314.368 412.777 316.551C411.216 318.734 408.148 319.261 405.924 317.729L400.6 314.062C398.376 312.53 397.838 309.519 399.399 307.336Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.176 311.311C126.788 309.019 123.769 308.265 121.433 309.628L116.74 312.367C114.405 313.73 113.637 316.693 115.026 318.985C116.414 321.277 119.433 322.03 121.769 320.667L126.462 317.928C128.798 316.565 129.565 313.602 128.176 311.311Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M122.514 230.274C122.514 227.607 120.311 225.445 117.594 225.445H93.0315C90.3144 225.445 88.1119 227.607 88.1119 230.274C88.1119 232.94 90.3144 235.102 93.0315 235.102H117.594C120.311 235.102 122.514 232.94 122.514 230.274Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M402.08 262.119C402.08 259.453 404.283 257.291 407 257.291H431.562C434.279 257.291 436.482 259.453 436.482 262.119C436.482 264.786 434.279 266.947 431.562 266.947H407C404.283 266.947 402.08 264.786 402.08 262.119Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M196.382 105.084C193.932 106.238 192.9 109.122 194.076 111.526L206.59 137.115C207.766 139.518 210.705 140.532 213.154 139.378C215.604 138.224 216.636 135.34 215.461 132.936L202.946 107.347C201.77 104.943 198.831 103.93 196.382 105.084Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M136.221 134.845C134.262 136.692 134.2 139.749 136.082 141.671L152.636 158.545C154.518 160.468 157.632 160.529 159.592 158.682C161.551 156.834 161.613 153.778 159.731 151.855L143.177 134.981C141.295 133.058 138.181 132.997 136.221 134.845Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.4308 168.597C82.9582 170.838 83.6154 173.826 85.8987 175.271L119.394 196.473C121.677 197.918 124.722 197.273 126.195 195.032C127.667 192.791 127.01 189.803 124.727 188.358L91.2316 167.156C88.9483 165.711 85.9035 166.356 84.4308 168.597Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M176.463 346.869C175.137 344.541 172.14 343.709 169.768 345.01L145.866 358.12C143.494 359.421 142.646 362.362 143.972 364.69C145.297 367.018 148.294 367.85 150.666 366.549L174.568 353.439C176.94 352.138 177.788 349.197 176.463 346.869Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.031 407.855C217.67 406.537 214.666 407.346 213.322 409.664L202.386 425.962C201.042 428.28 201.867 431.228 204.228 432.547C206.589 433.866 209.593 433.056 210.937 430.739L221.874 414.44C223.218 412.122 222.393 409.174 220.031 407.855Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.202 307.336C127.642 305.154 124.573 304.626 122.349 306.158L117.025 309.825C114.801 311.357 114.264 314.368 115.825 316.551C117.386 318.734 120.454 319.261 122.678 317.729L128.002 314.062C130.226 312.53 130.763 309.519 129.202 307.336Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M400.425 311.311C401.814 309.019 404.833 308.265 407.168 309.628L411.862 312.367C414.197 313.73 414.964 316.693 413.576 318.985C412.187 321.277 409.168 322.03 406.833 320.667L402.139 317.928C399.804 316.565 399.037 313.602 400.425 311.311Z"
        fill="#FEAC06"
      />
      <path
        d="M364.713 186.465H338.94V175.467C338.94 174.257 337.932 173.268 336.699 173.268H193.266C192.034 173.268 191.025 174.257 191.025 175.467V186.465H165.252C161.983 186.465 158.848 187.739 156.536 190.008C154.224 192.277 152.926 195.354 152.926 198.562V239.253C152.926 261.715 169.734 280.384 191.641 283.793C195.956 315.741 222.121 340.925 254.898 344.417V373.34H199.99C195.031 373.34 191.025 377.272 191.025 382.138V391.019C191.025 392.228 192.034 393.218 193.266 393.218H336.699C337.932 393.218 338.94 392.228 338.94 391.019V382.138C338.94 377.272 334.934 373.34 329.976 373.34H275.068V344.417C307.845 340.925 334.01 315.741 338.324 283.793C360.231 280.384 377.04 261.715 377.04 239.253V198.562C377.04 195.354 375.741 192.277 373.429 190.008C371.118 187.739 367.983 186.465 364.713 186.465ZM191.025 263.337C180.632 260.066 173.096 250.498 173.096 239.253V206.26H191.025V263.337ZM356.869 239.253C356.869 250.525 349.334 260.093 338.94 263.337V206.26H356.869V239.253Z"
        fill="#FE9B06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M492.144 361.851C328.542 274.978 182.817 284.982 37.7711 361.865V319.454L1.48242 295.923C167.379 207.988 340.47 196.101 528.482 295.935L492.144 319.454V361.851Z"
        fill="#5D33C3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M278.984 273.751H266.53L266.61 245.305H258.369L258.276 280.853H278.984V273.751ZM240.477 269.117C239.361 278.255 232.13 282.772 225.045 283.412C215.355 284.299 206.716 276.884 205.759 266.701C204.802 256.519 211.448 247.668 221.576 246.754C224.199 246.388 226.872 246.63 229.383 247.46C231.894 248.29 234.173 249.684 236.037 251.532L231.213 257.811C230.298 256.472 229.025 255.408 227.533 254.735C226.041 254.062 224.389 253.808 222.759 253.999C217.682 254.456 214.053 259.77 214.625 265.892C215.196 272.015 219.769 276.414 224.833 275.957C228.754 275.592 232.409 272.759 231.997 268.425L223.703 269.182L223.118 262.955L239.759 261.44L240.477 269.117ZM173.061 290.082L181.182 288.712L177.395 267.093H177.474L195.458 286.454L203.579 285.083L197.478 250.044L189.344 251.349L193.132 273.086H193.052L175.082 253.738L166.947 255.044L173.061 290.082ZM167.493 291.466L159.452 293.229L151.543 258.556L159.598 256.793L167.493 291.466ZM145.802 270.657C143.954 263.908 138.092 261.767 131.606 263.477L119.112 266.793L128.549 301.114L136.524 298.999L132.802 285.435L147.197 296.166L157.325 293.477L141.375 282.485C143.365 281.294 144.885 279.477 145.689 277.329C146.492 275.181 146.532 272.83 145.802 270.657ZM137.574 273.412C138.744 277.694 135.208 278.868 132.191 279.665L131.261 279.913L128.788 270.918L129.719 270.67C132.736 269.874 136.404 269.13 137.574 273.412ZM101.528 272.289C108.24 270.109 114.421 271.885 116.76 278.817C119.099 285.749 115.364 291.284 108.652 293.451L103.946 294.978L108.147 307.498L100.318 310.03L88.9933 276.284L101.528 272.289ZM104.093 288.19C107.176 287.198 109.755 285.227 108.599 281.793C107.442 278.36 104.173 278.229 101.089 279.182L98.8823 279.9L101.887 288.856L104.093 288.19ZM83.237 281.258L82.4796 288.464C79.9197 287.895 77.2528 287.994 74.744 288.752C72.0857 289.744 71.195 291.441 71.8994 293.243C72.6039 295.044 76.3388 295.214 80.8181 295.37C85.2974 295.527 90.5478 297.107 92.2491 301.441C95.3461 309.365 90.295 314.496 83.7023 316.95C79.0949 318.736 73.9952 318.874 69.2943 317.342L70.6235 309.509C70.6235 309.509 76.5916 311.558 80.3664 310.135C82.0412 309.509 85.1776 308.138 83.9548 305.044C83.203 303.093 80.4289 302.897 76.867 302.646C76.0209 302.586 75.1303 302.523 74.2119 302.433C69.4268 301.963 65.7987 299.822 64.443 296.323C62.0239 290.135 66.0507 284.091 71.5003 282.042C75.251 280.662 79.3307 280.39 83.237 281.258ZM305.833 253.869L293.392 253.151L292.966 260.2L304.929 260.892L304.504 267.981L292.541 267.289L292.115 274.43L304.557 275.148L304.131 282.25L283.463 281.049L285.59 245.579L306.258 246.767L305.833 253.869ZM333.427 285.552L342.213 286.649L332.271 249.6L324.707 248.647L305.661 282.093L314.459 283.19L318.022 276.479L331.672 278.177L333.427 285.552ZM326.994 260.018H327.127L329.759 270.775L321.677 269.769L326.994 260.018ZM378.38 281.611C374.592 290.044 366.337 292.29 359.372 290.88C349.842 288.948 343.795 279.326 345.881 269.379C347.968 259.431 356.966 252.786 366.935 254.81C369.551 255.213 372.036 256.21 374.191 257.722C376.346 259.233 378.113 261.217 379.35 263.517L372.863 268.152C372.384 266.607 371.48 265.222 370.252 264.148C369.023 263.075 367.517 262.355 365.899 262.068C360.914 261.063 355.863 265.11 354.601 271.141C353.338 277.172 356.395 282.668 361.38 283.673C365.248 284.457 369.58 282.786 370.471 278.517L362.31 276.872L363.639 270.749L380.015 274.065L378.38 281.611ZM392.681 298.868C401.573 301.323 407.528 298.307 409.96 289.847L416.341 267.785L408.366 265.592L402.703 285.37C401.055 291.101 398.808 292.302 394.927 291.192C391.046 290.082 389.744 287.967 391.378 282.249L397.054 262.459L389.079 260.266L382.753 282.328C380.32 290.787 383.789 296.414 392.681 298.868ZM440.452 283.398L428.676 279.416L426.323 286.088L437.608 289.912L435.242 296.636L423.971 292.811L421.591 299.573L433.328 303.62L430.975 310.343L411.397 303.711L423.187 270.109L442.765 276.727L440.452 283.398ZM469.959 287.315L457.89 289.443L454.74 296.845L461.731 295.605L452.001 318.451L459.605 321.571L473.561 288.79L469.959 287.315Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_2167_88019"
          x="0.200195"
          y="0"
          width="528.936"
          height="572"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0196078 0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2167_88019"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2167_88019"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SpringLeagueIcon;
